/**
 * True during react-snap / headless prerender and other non-interactive browsers.
 * Used to skip geo IP and exchange-rate network calls that spam APIs during build.
 */
export function isPrerenderOrSnap() {
  if (typeof navigator === "undefined") return true;
  const ua = navigator.userAgent || "";
  return /ReactSnap|HeadlessChrome|prerender/i.test(ua);
}
